import { render, staticRenderFns } from "./LeakageCauseOutsideHouseQuestion.vue?vue&type=template&id=72423dd6"
import script from "./LeakageCauseOutsideHouseQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseOutsideHouseQuestion.vue?vue&type=script&lang=ts"
import style0 from "./LeakageCauseOutsideHouseQuestion.vue?vue&type=style&index=0&id=72423dd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports